import { ClipType } from '@/shared/apis/editor/clip-types';
import {
  BaseItem,
  CanHaveBorderRadius,
  CanHaveCrop,
  CanHaveZoomKeyframes,
  CanHaveAnimation,
  CanHaveRotation,
  RenderMetaBaseItemCore,
} from '../shared';
import {
  EditorItemType,
  EditorStarterItem,
} from '@/features/remotion-editor/editor/items/item-type';

export type ImageItemRenderMeta = {
  clipType: Extract<ClipType, 'image'>;
  start: number;
  end: number;
} & RenderMetaBaseItemCore;

export type ImageItem = BaseItem &
  CanHaveBorderRadius &
  CanHaveCrop &
  CanHaveZoomKeyframes &
  CanHaveAnimation &
  CanHaveRotation & {
    type: Extract<EditorItemType, 'image'>;
    assetId: string;
    templateEffect?: unknown;
    ssulTemplateEffect?: unknown;
    backgroundColor?: string;
    boxShadow?: string;
    objectPosition?: string;
    keepAspectRatio: boolean;
    fadeInDurationInSeconds: number;
    fadeOutDurationInSeconds: number;
    renderMeta?: ImageItemRenderMeta;
  };

export const isImageItem = (item?: EditorStarterItem): item is ImageItem => {
  if (!item) return false;

  return item.type === 'image';
};
